/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { batchActions } from 'redux-batched-actions';
// actions
import { invalidateSelectedContent } from 'state/actions/embedsState/embedManagementState/content_status';
import { discardContentChanges } from 'state/actions/embedsState/embedManagementState/content_status';
import { discardEmbedChanges } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { sendErrorMessage } from '@insticator/insticator-ui'; // iui-state
// component
import EmbedUpdateCTA from 'material/embeds/embedupdatecta/embedupdatecta';



/* ========== ~~~~~~~~~~ EMBED UPDATE CTA : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    return {
        selectedContent: !!contentStatus.contents ? contentStatus.contents[contentStatus.selectedContent] : null,
        isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
        isSavingData: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isSavingData,
        changeDetected: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedChangeDetected ||
            embedsState.embedManagementState.contentStatus.contentChangeDetected,
        uploadingCustomImage: embedsState.embedManagementState.contentStatus.uploadingCustomImage
    }
};

// map actions
const mapDispatchToProps = dispatch => ({
    discardChanges: () => dispatch(batchActions([
        discardContentChanges(),
        discardEmbedChanges()
    ])),
    invalidateSelectedContent: () => dispatch(invalidateSelectedContent()),
    sendErrorMessage: message => dispatch(sendErrorMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmbedUpdateCTA);
